export default __webpack_public_path__ + "static/media/ProjectOwner.4cba59b2.svg";